import useSWR from 'swr';
import { format, addHours } from 'date-fns';

import { useToast } from '../../../hooks/toast';
import { useAuth } from '../../../hooks/auth';
import api from '../../../services/api';

import { formatedInputBRL } from '../../../utils/formatedInputs';

export const useFetchBillsToReceives = (url) => {
  const { signOut } = useAuth();
  const { addToast } = useToast();

  const { data, error, mutate } = useSWR(
    url,
    async () => {
      const response = await api.get(url);

      const billsToReceives = response.data.map((bills) => {
        return {
          id: bills.id,
          maturity_date: format(
            addHours(new Date(bills.maturity_date), 6),
            'dd/MM/yyyy'
          ),
          account_plan: bills.account_plan?.name,
          description: bills.description,
          client: bills.peoples
            ? bills.peoples.pj?.fantasy_name || bills.peoples.pf?.name
            : '',
          amount: bills.received
            ? formatedInputBRL(bills.received_amount)
            : formatedInputBRL(bills.amount),
          received:
            (bills.received && !bills.received_partial && 'Recebido') ||
            (bills.received && bills.received_partial && 'Recebido*') ||
            (!bills.received &&
              !bills.received_partial &&
              bills.past &&
              'Em Atraso') ||
            (!bills.received && !bills.received_partial && 'Em Aberto'),
          past: bills.past,
        };
      });

      return { data: billsToReceives };
    },
    {
      revalidateOnReconnect: true,

      onError: (err) => {
        if (err.response.status === 401) {
          addToast({
            type: 'error',
            title: 'Sessão expirada. Faça seu login.',
          });
          signOut();
        }
      },
    }
  );

  return {
    dataList: data && data.data,
    loading: !data && !error,
    error,
    mutate,
  };
};
